import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const getReviews = params => Http.get(`/reviews/fetch${serialize(params)}`)

export const getStats = (
	params = {
		language_id: '',
		status_id: 1,
	},
) => Http.get(`reviews/stats?filters[status_id]=${params.status_id}&filters[language_id]=${params.language_id}`)

export const newReview = (params = '') => Http.post('/creator-mode/new-review', params, { baseURL: 'locale' })

// The creator-mode routes are slug-keyed, but a review can carry an empty slug
// (an AI job whose model returned no title). That built /creator-mode/review/
// with a missing segment, which 404s — the record could not be opened, saved or
// deleted from the admin. The backend accepts the id as a fallback key.
export const reviewKey = params => (params && params.slug ? params.slug : params && params.id)

export const updateReview = (params = '') =>
	Http.put(`/creator-mode/review/${reviewKey(params)}`, params, { baseURL: 'locale' })

export const getReviewBySlug = slug => {
	return Http.get(`creator-mode/review/${slug}`, { baseURL: 'locale' })
}
